(function() {
    'use strict';

    angular.module('GorillaBoy.Login')
    .controller('OAuth2CallbackController', [
        '$location',
        '$log',
        '$window',
        'AuthService',
        'UserService',
        'authenticatedUser',
        'localStorageService',
        'AppConstants',
        OAuth2CallbackController
    ]);

    /*
    * The OAuth2CallbackController handles the OAuth 2.0 callback mechanism.
    *
    * This controller is called on successful authorization from the Authorization Server
    * (Galaxy in our case, but it doesn't matter what that server is).
    *
    * -- Authorization Code --
    * The authorization server provides us with *authorization code* in the query string.
    * The auth code is a short-lived token representing the user's access grant
    * created by the authorization server. Upon reception of this authorization code, we send it
    * to the (GorillaBoy) Auth service to obtain an *access token* and a *refresh token*.
    *
    * -- Access Token & Refresh Token --
    * The access token is used to make authenticated requests to the resource server (e.g. GorillaBoy).
    * It  has a longer lifetime than the authorization code (e.g. GorillaBoy's is 1 hour at
    * the time of this writing). When the access token expires, attempts to use it will fail,
    * and a new access token must be obtained via the refresh token.
    *
    * For information on how OAuth 2.0 works, check out the Salesforce documention:
    * https://developer.salesforce.com/page/Digging_Deeper_into_OAuth_2.0_on_Force.com#OAuth_2.0_Basics
    */
    function OAuth2CallbackController ($location, $log, $window, authService, UserService, authenticatedUser, localStorageService, AppConstants) {
        var GALAXY_AUTH_CODE_PARAM_NAME = 'auth_code';

        activate();


        /**
         * Main function that gets invoked when this controller is activated.
         */
        function activate () {
            var querystring_params = $location.search();

            if (querystring_params && querystring_params[GALAXY_AUTH_CODE_PARAM_NAME]) {
                processAuthorizationCode(querystring_params[GALAXY_AUTH_CODE_PARAM_NAME]);
            } else {
                // If there is no auth token as a param, there's nothing we can do other than redirect to login page
                // Always use url() to redirect to other routes, with path() the search params are not cleared, so the target
                // route will get unwanted params in its $routeParams
                $location.url('/login').replace();
            }
        }

        /**
        * Processes the authorization code received by the authorization server and obtains
        * an access token to be used for subsequent authenticated requests.
        *
        */
        function processAuthorizationCode (authCode) {
            authService
                .obtainAccessToken(authCode)
                .then(accessTokenCreationDidSucceed, accessTokenCreationDidFail);
        }

        /**
         * Handles the successful creation of an access token, redirect to AuthSuccess page.
         *
         * Note: this has nothing to do with success/failure of refreshing an access token.
         * This controller only deals with the creation of an access token by exchanging a short-lived
         * authorization code for an access token.
         */
        function accessTokenCreationDidSucceed (result) {
            $log.info(new Date().toISOString() + ' [OAuth2CallbackController] authentication succeeded');
            var data = result.data;
            //Always encode the query params, especially when you're delimiting each query/param value using &/= yourself
            $location.url('/authSuccess?' +
                AppConstants.WorkDocsAuthParams.ACCESS_TOKEN + '=' + encodeURIComponent(data.AccessToken) +
                '&' + AppConstants.WorkDocsAuthParams.ACCESS_TOKEN_EXPIRATION + '=' + encodeURIComponent(data.ExpirationDateTime) +
                '&' + AppConstants.WorkDocsAuthParams.REFRESH_TOKEN + '=' + encodeURIComponent(data.RefreshToken)).replace();
        }

        /**
         * Handles the failed creation of an access token.
         *
         * Note: same as above, this has nothing to do with the failure to refresh an access token.
         * This failure handling is only when attempting to obtain a brand new access token after
         * obtaining an authorization code.
         */
        function accessTokenCreationDidFail (error) {
            // TODO: show an actual error to the user or try again if it's a 500 error
            $log.error('An error occured while trying to get an access token: ' + error);
            if (error && error.indexOf('403') === 0 && error.indexOf('is not Active in') >= 0) {
                // User account is valid but has not been activated for GorillaBoy

                // Remove auth code from the URL/query string
                $location.search(GALAXY_AUTH_CODE_PARAM_NAME, null).replace();
                // Always use url() to redirect to other routes, with path() the search params are not cleared, so the target
                // route will get unwanted params in its $routeParams
                $location.url('not_active').replace();
            } else {
                // Always use url() to redirect to other routes, with path() the search params are not cleared, so the target
                // route will get unwanted params in its $routeParams
                $location.url('/login').replace();
            }
        }
    }
}());
